import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAppMode } from "src/contexts/app-mode";

import { PendingSlotSelection } from "@models/services/kiosk";
import kioskSlice from "@slices/kiosk.slice";
import { RootState } from "@store/index";

export const useKioskAuth = () => {
  const dispatch = useDispatch();
  const { isKioskMode } = useAppMode();
  const isAuthenticated = useSelector(
    (state: RootState) => state.local.isAuthenticated
  );

  const requireAuth = useCallback((): boolean => {
    if (isKioskMode && !isAuthenticated) {
      dispatch(kioskSlice.actions.setShowLoginModal(true));
      return false;
    }
    return true;
  }, [isKioskMode, isAuthenticated, dispatch]);

  const requireAuthForSlot = useCallback(
    (pending: PendingSlotSelection): boolean => {
      if (isKioskMode && !isAuthenticated) {
        dispatch(kioskSlice.actions.setPendingSlotSelection(pending));
        dispatch(kioskSlice.actions.setShowLoginModal(true));
        return false;
      }
      return true;
    },
    [isKioskMode, isAuthenticated, dispatch]
  );

  return {
    isAuthenticated,
    isKioskMode,
    requireAuth,
    requireAuthForSlot,
  };
};
